import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    talks: [],
    totalPages: null,
    totalTalks: null,
    selectedTalk: null,
    isLoading: false,
    error: null
}

const talksSlice = createSlice({
    name: "talks",
    initialState,
    reducers: {
        setTalks: (state, action) => {
            state.talks = action.payload;
        },
        setSelectedTalk: (state, action) => {
            state.selectedTalk = action.payload;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload
        },
        setTotalTalks: (state, action) => {
            state.totalTalks = action.payload
        }
    }
})

export const { setTalks, setSelectedTalk, setLoading, setError, setTotalPages, setTotalTalks } = talksSlice.actions;
export const talksReducers = talksSlice.reducer;